import { createSelector } from 'reselect'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectWelcomeFlowIsSaving = createSelector(
  selectWelcomeFlowState,
  (state) => state.isSaving
)
